import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=08fc8215"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports